import axios from 'axios';
import qs from 'qs';
import { get } from 'lodash';

const BANNEDCASHREGISTERS_LIST_LOAD = 'BANNEDCASHREGISTERS_LIST_LOAD';
const BANNEDCASHREGISTERS_LIST_SUCCESS = 'BANNEDCASHREGISTERS_LIST_SUCCESS';
const BANNEDCASHREGISTERS_LIST_FAILED = 'BANNEDCASHREGISTERS_LIST_FAILED';
const BANNEDCASHREGISTERS_SET_LOADING = 'BANNEDCASHREGISTERS_SET_LOADING';

const BANNEDCASHREGISTERS_FORM_LOAD = 'BANNEDCASHREGISTERS_FORM_LOAD';
const BANNEDCASHREGISTERS_FORM_SUCCESS = 'BANNEDCASHREGISTERS_FORM_SUCCESS';
const BANNEDCASHREGISTERS_FORM_FAILED = 'BANNEDCASHREGISTERS_FORM_FAILED';

const BANNEDCASHREGISTER_DELETE_LOAD = 'BANNEDCASHREGISTER_DELETE_LOAD';
const BANNEDCASHREGISTER_DELETE_SUCCESS = 'BANNEDCASHREGISTER_DELETE_SUCCESS';
const BANNEDCASHREGISTER_DELETE_FAILED = 'BANNEDCASHREGISTER_DELETE_FAILED';

const BANNEDCASHREGISTER_EDIT_LOAD = 'BANNEDCASHREGISTER_EDIT_LOAD';
const BANNEDCASHREGISTER_EDIT_SUCCESS = 'BANNEDCASHREGISTER_EDIT_SUCCESS';
const BANNEDCASHREGISTER_EDIT_FAILED = 'BANNEDCASHREGISTER_EDIT_FAILED';

const BANNEDCASHREGISTER_VIEW_LOAD = 'BANNEDCASHREGISTER_VIEW_LOAD';
const BANNEDCASHREGISTER_VIEW_SUCCESS = 'BANNEDCASHREGISTER_VIEW_SUCCESS';
const BANNEDCASHREGISTER_VIEW_FAILED = 'BANNEDCASHREGISTER_VIEW_FAILED';

const BANNEDCASHREGISTERS_RESET = 'BANNEDCASHREGISTERS_RESET';
const BANNEDCASHREGISTERS_RESET_FORM = 'BANNEDCASHREGISTERS_RESET_FORM';

const initialState = {
  loading: false,
  success: false,
  saved: false,
  failed: false,
  data: [],
  message: null,
  total: 0,
  limit:process.env.REACT_APP_LIST_LIMIT,
  page: null,
  order: '',
  orderMode: 'ASC',
  deleted: false,
  deletedId: null,
  formErrors: {},
  viewData: null,
  viewLoading: false,
  commentThread: false,
  id: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case BANNEDCASHREGISTERS_RESET:
      return {
        ...initialState
      };
    case BANNEDCASHREGISTERS_RESET_FORM:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        formErrors: {},
        viewData: null,
        viewLoading: false,
        commentThread: false,
        id: null
      };
    case BANNEDCASHREGISTER_DELETE_LOAD:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        viewLoading: false
      };
    case BANNEDCASHREGISTERS_LIST_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        viewLoading: false
      };
    case BANNEDCASHREGISTER_EDIT_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: false
      };
    case BANNEDCASHREGISTER_VIEW_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: true
      };
    case BANNEDCASHREGISTERS_FORM_LOAD:
      return {
        ...state,
        loading: false,
        failed: false,
        message: null,
        viewLoading: false
      };
    case BANNEDCASHREGISTERS_FORM_FAILED:
    case BANNEDCASHREGISTER_EDIT_FAILED:
    case BANNEDCASHREGISTER_DELETE_FAILED:
    case BANNEDCASHREGISTERS_LIST_FAILED:
    case BANNEDCASHREGISTER_VIEW_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        saved: false,
        failed: true,
        message: action.message,
        formErrors: action.formErrors || {},
        deleted: true,
        deletedId: null,
        viewLoading: false
      };
    case BANNEDCASHREGISTERS_LIST_SUCCESS:
      return {
        ...state,
        success: true,
        failed: false,
        data: action.data,
        total: action.total,
        limit: action.limit,
        page: action.page,
        order: action.order,
        orderMode: action.orderMode
      };
      case BANNEDCASHREGISTER_VIEW_SUCCESS:
        return {
            ...state,
            loading: false,
            success: true,
            failed: false,
            viewData: action.viewData,
            viewLoading: false
        };
    case BANNEDCASHREGISTERS_FORM_SUCCESS:
      return {
        ...state,
        fields: action.fields,
        loading: false,
        success: true,
        failed: false,
        viewLoading: false
      };
    case BANNEDCASHREGISTER_DELETE_SUCCESS:
      return {
        ...state,
        deleted: true,
        deletedId: action.id
      };
    case BANNEDCASHREGISTER_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        saved: true,
        failed: false,
        message: null,
        formErrors: {},
        id: action.id,
        viewLoading: false
      };
    case BANNEDCASHREGISTERS_SET_LOADING:
      return {
        ...state,
        loading: action.loading,
        viewLoading: false
      };
    default:
      return state;
  }
}

export const reset = () => dispatch => {
  dispatch({
    type: BANNEDCASHREGISTERS_RESET
  });
};

export const resetForm = () => dispatch => {
  dispatch({
    type: BANNEDCASHREGISTERS_RESET_FORM
  });
};

export const updateBannedCashregisters = (model,id,data) => dispatch => {
  dispatch({
    type: BANNEDCASHREGISTER_EDIT_LOAD
  });

    let obj = {};
    obj[model] = data;

  return axios.put('/v1/banned-cashregisters/'+id, obj).then(
      () => dispatch({
        type: BANNEDCASHREGISTER_EDIT_SUCCESS
      })
  ).catch(error => {
    dispatch({
      type: BANNEDCASHREGISTER_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const viewBannedCashregisters = (id) => dispatch => {
    dispatch({
        type: BANNEDCASHREGISTER_VIEW_LOAD
    });
    return axios.get('/v1/banned-cashregisters/'+id).then(
        response => dispatch({
            type: BANNEDCASHREGISTER_VIEW_SUCCESS,
            viewData: get(response, 'data.data'),
            commentThread: get(response, 'data.commentThread', false)
        })
    ).catch(error => {
        dispatch({
            type: BANNEDCASHREGISTER_VIEW_FAILED,
            message: get(error, 'response.data.message', null)
        })
    });
};

export const createBannedCashregisters = (model, data) => dispatch => {
  dispatch({
    type: BANNEDCASHREGISTER_EDIT_LOAD
  });

  let obj = {};
  obj[model] = data;

  return axios.post('/v1/banned-cashregisters', obj).then(response => dispatch({
    type: BANNEDCASHREGISTER_EDIT_SUCCESS,
    id: get(response, 'data.data.id', null),
  })).catch(error => {
    dispatch({
      type: BANNEDCASHREGISTER_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const BannedCashregisterDelete = (id) => dispatch => {
  dispatch({
    type: BANNEDCASHREGISTER_DELETE_LOAD
  });
  return axios.delete('/v1/banned-cashregisters/'+id)
      .then((response) => dispatch({
        type: BANNEDCASHREGISTER_DELETE_SUCCESS,
        id
      })).catch(error => dispatch({
        type: BANNEDCASHREGISTER_DELETE_FAILED,
        message: get(error, 'response.data.message', null)
      }));
};

export const setLoading = (loading) => dispatch => {
  dispatch({
    type: BANNEDCASHREGISTERS_SET_LOADING,
    loading
  });
};

export const BannedCashregistersList = (page, keyword, sort, filters, perPage) => dispatch => {
  dispatch({
    type: BANNEDCASHREGISTERS_LIST_LOAD
  });

  let params = {
    page,
    keyword,
    sort,
    'per-page': perPage
  };

  params[filters.model] = filters.filters;

  return axios.get(
      '/v1/banned-cashregisters',
      {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        }
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
  ).then(response => {
    let sort = get(response, 'data.sort', null),
        mode = 'ASC';
    if(sort && sort.indexOf('-') !== -1) {
      mode = 'DESC';
      sort = sort.substr(1);
    }
    return dispatch({
      type: BANNEDCASHREGISTERS_LIST_SUCCESS,
      data: get(response, 'data.data', null),
      page: get(response, 'data.page', 0),
      limit: get(response, 'data.per-page', 0),
      total: get(response, 'data.total', 0),
      order: sort,
      orderMode: mode
    });
  })
  .catch(error => dispatch({
    type: BANNEDCASHREGISTERS_LIST_FAILED,
    message: get(error, 'response.data.message', null)
  }));
};
